/*
 *  I17TARIFC16I18n.js
 *
 *  Created by Sébastien Hecart on 2018-08-05 14:44:59 +0000.
 *  Copyright © 2017 Sebastien Hecart. All rights reserved.
 *
 *
 */

export default {
  I17TARIFC16_SECTION_0_TITLE: 'Performance Cogénérateur',
  I17TARIFC16_in_rendElecModule: 'Rendement électrique du module',
  I17TARIFC16_in_rendThermiqueModule: 'Rendement thermique du module',
  I17TARIFC16_in_partElecConso: "Part d'électricité autoconsommée",
  I17TARIFC16_in_tarif: 'Tarif B1 niveau 3 (TTC)',
  I17TARIFC16_res_rendementElectReference: 'Rendement électrique de référence',
  I17TARIFC16_res_rendThermiqueReference: 'Rendement thermique de référence',
  I17TARIFC16_res_ep: 'Ep',
  I17TARIFC16_SECTION_1_TITLE: 'Résultat',
  I17TARIFC16_res_tarif: 'Tarif C16 (hiver)',
  I17TARIFC16_conclusion: 'Selon document du 11/2016'
}
